(ns guidebook.views.footer
  (:import
   [goog.date DateTime])
  (:require
   [cljss.core :as cljss]
   [branding.views :as branding]
   [css.core :as css
    :refer [class-names get-theme]
    :refer-macros [defstyled]]
   [very.re-frame.core :as rf]))

(defstyled footer-s :section
  {:position "absolute"
   :display "grid"
   :grid-template-columns "1fr 1fr 1fr"
   :width "100%"
   :bottom "40px"
   ::cljss/media {[:only :screen]
                  {:display "none"}}})

(defstyled center-s :div
  {:align-self "center"
   :justify-self "center"})

(defstyled footer-name-s :div
  {:font-size "22px"
   :text-align "left"})

(defstyled footer-name-sub-s :div
  {:font-size "16px"
   :font-weight 300
   :text-align "left"})

(defstyled footer-date-s :div
  {:font-size "24px"
   :font-weight 300
   :text-align "right"})

(defn main []
  (let [data (rf/subscribe [:guidebook/footer])]
    (fn [{:keys [footer-left footer-right]}]
      [footer-s
       [center-s {:style {:color (if footer-left footer-left "black")}}
        [footer-name-s (get-in @data [:client :name])]
        [footer-name-sub-s "Household"]]
       [center-s
        [branding/logo]]
       [center-s
        [footer-date-s {:style {:color (if footer-right footer-right "black")}} (util.core/to-utc-time (.toString (DateTime.)) "MMM YYYY")]]])))
